
import { useEffect, useState } from "react";
import '../../assets/css/manage.css'
import '../../App.css'
import Input from "../../components/Input";
import DataGridMUI from "../../components/DataGridMUI";
import axiosInstance from '../../api/axiosInstance'
import { useNavigate } from "react-router-dom";
import { alert, confirm, getCurrentTimestamp } from "../../utils/comm";
import MngrNavi from "./MngrNavi";
import local from "../../utils/local";

const NtfctMng = () => {

    const navigate = useNavigate();
    const [hasMounted, setHasMounted] = useState(false); // 최초마운트 여부 
    const [check , setCheck] = useState(0); // 마스터 재조회용 상태 -> 마스터그리드는 수정안됨 -> 사용X
    const [masterItemList, setMasterItemList] = useState([]); // 마스터 아이템 
    const isAddingNew = masterItemList.some(item => item.status === 'new');  // readonly flag 신규 버튼 눌렀을때 사용함
    const [isDisable, setIsDisable] = useState(true); // 일반 readonly flag
    const [detailItem, setDetailItem] = useState({
        NTFCT_VER : null      // 알림 버전
        , NTFCT_CN : null     // 알림 내용
        , WRTR : null         // 작성자
        , DEL_YN : null         // 삭제여부
        , status : null
    }); // 디테일 아이템 리스트
    const master_Grid_Columns = [
        { id: 'index', name: '순번', type: 'index'},
        { id: 'NTFCT_CN', name: '알림 내용', width: '500', readOnly: 'true'},
        { id: 'WRTR', name: '작성자', textAlign: 'center', absReadOnly: 'true'},
        { id: 'MDFCN_DT', name: '작성일자', width: '300', textAlign: 'center', absReadOnly: 'true'},
    ];

    useEffect(() => {
        S_01();
    }, []); // 의존성 배열이 비어 있음 → mount 시 1회만 실행

    useEffect(() => {
        if (!hasMounted) {
            setHasMounted(true);
            return;
        }
        S_01();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [check]);

    // 마스터 조회
    const S_01 = async () => {
        try {
            const NtfctRes = await axiosInstance.get('/ntfctMng/findNtfctMng');
            
            // 아이템 상태값 추가 
            NtfctRes.data.forEach(element => {
                element.status = 'load';
            });
            setMasterItemList(NtfctRes.data);
            
        } catch (error) {
            console.error('Error ComponentMaster - S_01', error)
        }
    };

        // 신규추가 
    const addrow = async () => {
        if (isAddingNew) {
            await alert({body : "작성중인 데이터가 있습니다."});
            return
        }; // 이중 방지 안전장치

        const newRow = {
            NTFCT_VER: ''
            , NTFCT_CN: ''
            , DEL_YN: 'N'
            , WRTR: local.SESSION_USER_NAME 
            , MDFCN_DT: getCurrentTimestamp()
            , status: 'new' // 신규 플래그
        };

        detailItem.WRTR = local.SESSION_USER_NAME;
        detailItem.MDFCN_DT = getCurrentTimestamp();

        const updatedRows = [...masterItemList, newRow];
        setMasterItemList(updatedRows);
        setIsDisable(false);
    }

    // 마스터 저장
    const CU_01 = async () => {
        try {
            const confirmRes = await confirm({body : "저장 하시겠습니까?"});
            if (!confirmRes) return;

            await axiosInstance.post('/ntfctMng/createNtfctMng', {
                ...detailItem
            }); 

            await alert({body : "저장이 완료되었습니다."});
            
            // 재조회 
            setCheck(check+1);
            
            // 디테일 초기화 
            setDetailItem({
                NTFCT_VER : ''
                , NTFCT_CN : ''
                , WRTR : ''
                , STATUS : ''
                , MDFCN_DT : ''
                , DEL_YN : ''
            })
        } catch (error) {
            console.error(`Error ComponentDetail - CU_01`, error);
        };
    }
    
    // 마스터 삭제
    const D_01 = async () => {
        try {
            const newRowIdx = masterItemList.length -1;
            const element = masterItemList[newRowIdx];
            
            if (element.status === "new") {
                const newList = [...masterItemList];
                newList.splice(newRowIdx, 1);
                setMasterItemList(newList);
                return; // 서버 요청 없이 종료
            }

            const confirmRes = await confirm({body : "삭제 하시겠습니까?"});
            if (!confirmRes) return;
            
            await axiosInstance.post('/ntfctMng/deleteNtfctMng', {
                ...detailItem
            }); 

            await alert({body : "삭제가 완료되었습니다."});
            
            // 재조회 
            setCheck(check+1);
            
            // 디테일 초기화 
            setDetailItem({
                NTFCT_VER : ''
                , NTFCT_CN : ''
                , WRTR : ''
                , STATUS : ''
                , MDFCN_DT : ''
                , DEL_YN : ''
            })

        } catch (error) {
            console.error(`Error ComponentDetail - D_01`, error);
        }
    };

    const onPositionChange = async (idx,item) => {
        setDetailItem({
            NTFCT_VER : item.NTFCT_VER
            , NTFCT_CN : item.NTFCT_CN
            , WRTR : item.WRTR
            , STATUS : item.status
            , MDFCN_DT : item.MDFCN_DT
            , DEL_YN : item.DEL_YN
        })
        setIsDisable(false);
    }

return (
    <div className="shuriken before:content-[''] before:z-[-1] before:w-screen before:h-screen before:bg-slate-50 before:top-0 before:fixed before:bg-texture-black before:bg-contain before:bg-fixed before:bg-[center_-20rem] before:bg-no-repeat">
        {/* 관리자 네비게이션 */}
        <MngrNavi pgmId="NtfctMng"/>
        <section>
            <h1>알림관리</h1>

            <div className="form_container">
                <div className="notice_table" style={{ flexGrow: 1 }}>
                    <div className="n_tit">
                        <h2>알림 등록</h2>
                        <div style={{ display: "flex", gap: 8 }}>
                            <button className={`n_btn ${isAddingNew ? 'disabled-btn' : ''}`} disabled={isAddingNew} onClick={() => addrow()}>신규</button>
                            <button className={`n_btn color_btn ${isDisable ? 'disabled-btn' : ''}`} disabled={isDisable} onClick={() => D_01()}>삭제</button>
                            <button className={`n_btn color_btn ${isDisable ? 'disabled-btn' : ''}`} disabled={isDisable} onClick={() => CU_01()}>저장</button>
                        </div>
                    </div>
                        <div className="form_group full_width">
                            <Input 
                                bind = {detailItem}
                                setBind = {setDetailItem}
                                id = {"NTFCT_CN"}
                                maxLength={1000}
                                placeHolder="알림 내용"
                                type="textarea"
                                readOnly={isDisable}
                            ></Input>
                        </div>
                        <div className="form_group" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end' }}>
                        <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                            <div className="form_group">
                            <label htmlFor="author">작성자</label>
                            <Input 
                                bind = {detailItem}
                                setBind = {setDetailItem}
                                id = {"WRTR"}
                                maxLength={10}
                                placeHolder="작성자를 입력하세요"
                                readOnly={true}
                            ></Input>
                            </div>

                            <div className="form_group" style={{ width: '120px' }}>
                            <label htmlFor="status">작성일자</label>
                            <Input 
                                bind = {detailItem}
                                setBind = {setDetailItem}
                                id = {"MDFCN_DT"}
                                readOnly={true}
                                width="200"
                            ></Input>
                            </div>
                        </div>
                        </div>
                    </div>
                </div>
            <div className="notice_table" style={{ flexGrow: 2 }}>
                <DataGridMUI
                    columns={master_Grid_Columns}
                    data={masterItemList}
                    setBind={setMasterItemList}
                    pk="NTFCT_VER" // 고유키 지정
                    onPositionChange={(idx,item) => onPositionChange(idx,item)}
                ></DataGridMUI>
            </div>
        </section>
    </div>
    );
};

export default NtfctMng;
